import { createContext, useContext } from 'react';

import type {
  KanbanColumnProps,
  KanbanContextValue,
  KanbanItemProps,
} from './types';

const defaultContext: KanbanContextValue = {
  columns: [],
  data: [],
  activeCardId: null,
};

export const KanbanContext = createContext(defaultContext);

export function useKanbanContext<
  T extends KanbanItemProps = KanbanItemProps,
  C extends KanbanColumnProps = KanbanColumnProps,
>() {
  return useContext(KanbanContext) as KanbanContextValue<T, C>;
}
